import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import './Login.css';

const ResetPasswordForm = () => {
  const [params] = useSearchParams();
  const token = params.get('token');

  const [newPw, setNewPw] = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [isPasswordVisible1, setIsPasswordVisible1] = useState(false);
  const [isPasswordVisible2, setIsPasswordVisible2] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [validating, setValidating] = useState(true);
  const [isValid, setIsValid] = useState(false);

  const navigate = useNavigate();
  const API_URL = import.meta.env.VITE_API_URL;

  // --- トークン検証 ---
  useEffect(() => {
    if (!token) {
      setIsValid(false);
      setErrorText('リンクが無効です');
      setValidating(false);
      return;
    }
    (async () => {
      try {
        const res = await axios.post(`${API_URL}/api/password-reset-validate/`, { token });
        if (res.data?.valid) {
          setIsValid(true);
        } else {
          setIsValid(false);
          setErrorText(res.data?.message || 'リンクが無効です');
        }
      } catch (err) {
        const msg = err.response?.data?.message || 'リンクが無効です';
        setIsValid(false);
        setErrorText(msg);
      } finally {
        setValidating(false);
      }
    })();
  }, [token, API_URL]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newPw || newPw.length < 8) {
      setErrorText('パスワードは8文字以上で入力してください。');
      return;
    }
    if (newPw !== confirmPw) {
      setErrorText('確認用パスワードが一致しません。');
      return;
    }

    try {
      setSubmitting(true);
      setErrorText('');
      const res = await axios.post(
        `${API_URL}/api/password-reset/`,
        { token, new_password: newPw }
      );
      if (res.data?.success) {
        navigate('/auth/login-view/reset-success')
      } else {
        setErrorText(res.data?.message || 'パスワード再設定に失敗しました。');
      }
    } catch (err) {
      const msg = err.response?.data?.message || '通信エラーが発生しました。';
      setErrorText(msg);
    } finally {
      setSubmitting(false);
    }
  };

  // --- ローディング中 ---
  if (validating) {
    return (
      <div className="login-container">
        <div className="login-card">確認中...</div>
      </div>
    );
  }

  // --- 無効トークン時 ---
  if (!isValid) {
    return (
      <div className="login-container">
        <div className="login-card">
          <h2 className="login-title">新しいパスワードを設定</h2>
          <p>{errorText}</p>
          <Link to="/forgot-password">パスワード再設定へ</Link><br/>
          <Link to="/login">ログインへ戻る</Link>
        </div>
      </div>
    );
  }

  // --- 有効トークン時 (フォーム表示) ---
  return (
    <div className="login-container">
      <div className="login-card">
        <h2 className="login-title">新しいパスワードを設定</h2>
        {errorText && <div className="error-alert">{errorText}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="new-pw">新しいパスワード</label>
             <div className="password-field">
            <input
              id="new-pw"
              type={isPasswordVisible1 ? 'text' : 'password'}
              value={newPw}
              onChange={(e) => setNewPw(e.target.value)}
              required
              autoComplete="new-password"
            />
            <button
                type="button"
                className="toggle-password"
                onClick={() => setIsPasswordVisible1((v) => !v)}
                aria-label={isPasswordVisible1 ? 'パスワードを非表示' : 'パスワードを表示'}
              >
                {isPasswordVisible1 ? '隠す' : '表示'}
              </button>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="confirm-pw">確認用パスワード</label>
            <div className="password-field">
            <input
              id="confirm-pw"
              type={isPasswordVisible2 ? 'text' : 'password'}
              value={confirmPw}
              onChange={(e) => setConfirmPw(e.target.value)}
              required
              autoComplete="new-password"
            />
             <button
                type="button"
                className="toggle-password"
                onClick={() => setIsPasswordVisible2((v) => !v)}
                aria-label={isPasswordVisible2 ? 'パスワードを非表示' : 'パスワードを表示'}
              >
                {isPasswordVisible2 ? '隠す' : '表示'}
              </button>
            </div>
          </div>
          <button class="login-button" type="submit" disabled={submitting}>
            {submitting ? '送信中…' : '更新する'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
